import _components,{registerComponents} from './components/formComponents';
import _previewcomponents,{registerPreviewComponents} from './components/previewComponents';
import _filters,{registerFilters} from './filters';
import _formMixin from './mixins/formMixin';
import _previewMixin from './mixins/previewMixin';

export const formMixin = _formMixin;
export const previewMixin = _previewMixin;
export const components = _components;
export const previewComponents = _previewcomponents;
export const filters = _filters;

if(typeof window !== "undefined"){
  window.formComponents = window.fc = components;
  window.previewComponents = window.pc = previewComponents;
  window.formMixin = formMixin;
  if (window.Vue) {
    registerComponents(window.Vue);
    registerPreviewComponents(window.Vue);
    registerFilters(window.Vue);
  }
}


export default components;